import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const TimeSeriesEarningsChart = ({ rows }) => {
  const [chartData, setChartData] = useState({
    options: { xaxis: { categories: [] } },
    series: [{ name: "Earnings", data: [] }],
  });

  // Utility to format numbers like 9345 -> 9.34K
  const formatToK = (num) => {
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(2) + "M";
    if (num >= 1_000) return (num / 1_000).toFixed(2) + "K";
    return num.toString();
  };

  useEffect(() => {
    if (!rows || rows.length === 0) {
      setChartData({
        options: { xaxis: { categories: [] } },
        series: [{ name: "Earnings", data: [] }],
      });
      return;
    }

    const categories = rows.map((r) => r.label);
    const verificationStatuses = rows.map((r) => r.verificationStatuses || {});
    const earnings = rows.map((r) => r.earnings || 0);

    setChartData({
      options: {
        chart: { id: "time-series-earnings" },
        colors: ["#34D399"], // green for earnings
        xaxis: {
          categories,
          labels: {
            style: {
              colors: "#FFFFFF", // 👈 X-axis labels white
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#FFFFFF", // 👈 Y-axis labels white
            },
          },
        },
        tooltip: {
          custom: function ({ dataPointIndex }) {
            const day = rows[dataPointIndex];
            if (!day) return "";

            const total = day.verificationStatuses["VERIFIED"] || 0;
            const earnings = day.earnings || 0;
            const avg = total > 0 ? (earnings / total).toFixed(2) : 0;

            let tooltipHtml = `<div style="padding:8px;">
              <strong>${day.label}</strong><br/>
              <span>Earnings: ₹${earnings}</span><br/>
              <span>Avg Order Value: ₹${avg}</span><br/>
            </div>`;

            return tooltipHtml;
          },
        },
        dataLabels: {
          formatter: (val) => `₹${formatToK(val)}`,
        },
      },
      series: [{ name: "Earnings", data: earnings }],
    });
  }, [rows]);

  return (
    <Chart
      options={chartData.options}
      series={chartData.series}
      type="bar"
      width="100%"
      height={400}
    />
  );
};

export default TimeSeriesEarningsChart;
